import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

import { ButtonLinkComponent } from '@mode/capra';
import { SharedUtilToastModule, ToastAnimation } from '@mode/shared/util-toast';

@Component({
  standalone: true,
  selector: 'mode-google-sheet-ingest-failed',
  imports: [ButtonLinkComponent, SharedUtilToastModule],
  templateUrl: './google-sheet-ingest-failed.component.html',
  styleUrls: ['./google-sheet-ingest-failed.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [ToastAnimation],
})
export class GoogleSheetIngestFailedComponent extends Toast {
  readonly editDatasetLink = this.options.payload.editDatasetLink;

  dismissToast() {
    this.remove();
  }
}
